import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const EmergencyMedicineIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
    />
    <g clipPath='url(#clip0_414_17977)'>
      <path
        d='M28.0759 25.9517V19.2575C28.0759 18.8435 28.4118 18.5076 28.8258 18.5076H44.2062C44.6202 18.5076 44.9561 18.8435 44.9561 19.2575V25.9517H46.4637V19.2575C46.4637 18.0155 45.4482 17 44.2062 17H28.8258C27.5838 17 26.5684 18.0155 26.5684 19.2575V25.9517H28.0759Z'
        fill='#636C77'
      />
      <path
        d='M58.0401 23.53V50.8226C58.0401 51.6506 57.3684 52.3302 56.5326 52.3302H16.5076C15.6718 52.3302 15 51.6585 15 50.8226V23.53C15 22.702 15.6718 22.0225 16.5076 22.0225H56.5404C57.3684 22.0225 58.0401 22.6942 58.0401 23.53Z'
        fill='#4FC0E8'
      />
      <path d='M15 27.4514H58.0401V29.123H15V27.4514Z' fill='#4A88DA' />
      <path d='M15 45.23H58.0401V46.9016H15V45.23Z' fill='#4A88DA' />
      <path
        d='M41.7298 35.8329V38.5278H37.8632V42.3866H35.1762V38.5278H31.3096V35.8329H35.1762V31.9507H37.8632V35.8329H41.7298Z'
        fill='#F4F6F8'
      />
      <path d='M52.9082 32.6538H61.0163V37.5124H52.9082V32.6538Z' fill='#CAD0D7' />
      <path
        d='M62.079 31.6071V34.2473C62.079 34.5598 61.829 34.8097 61.5166 34.8097H52.4008C52.0883 34.8097 51.8384 34.5598 51.8384 34.2473V31.6071C51.8384 31.2946 52.0883 31.0447 52.4008 31.0447H61.5166C61.829 31.0447 62.079 31.2946 62.079 31.6071Z'
        fill='#636C77'
      />
      <path
        d='M63.6959 58.6578H50.2293C49.5107 58.6578 48.9326 58.0798 48.9326 57.3611V39.7389C48.9326 37.5908 50.6745 35.8489 52.8226 35.8489H61.1104C63.2585 35.8489 65.0004 37.5908 65.0004 39.7389V57.369C64.9926 58.0798 64.4146 58.6578 63.6959 58.6578Z'
        fill='#E4E8EB'
      />
      <path d='M48.9326 41.0198H64.9926V53.4866H48.9326V41.0198Z' fill='#9ED26A' />
      <path
        d='M60.4852 46.2689V48.2451H57.9466V50.7838H55.9703V48.2451H53.4395V46.2689H55.9703V43.7302H57.9466V46.2689H60.4852Z'
        fill='#F4F6F8'
      />
      <path d='M52.541 31.5134H53.0487V34.3411H52.541V31.5134Z' fill='#424852' />
      <path d='M53.7363 31.5134H54.2441V34.3411H53.7363V31.5134Z' fill='#424852' />
      <path d='M54.9238 31.5134H55.4316V34.3411H54.9238V31.5134Z' fill='#424852' />
      <path d='M56.1191 31.5134H56.6269V34.3411H56.1191V31.5134Z' fill='#424852' />
      <path d='M57.3062 31.5134H57.8139V34.3411H57.3062V31.5134Z' fill='#424852' />
      <path d='M58.4932 31.5134H59.0009V34.3411H58.4932V31.5134Z' fill='#424852' />
      <path d='M59.689 31.5134H60.1967V34.3411H59.689V31.5134Z' fill='#424852' />
      <path d='M60.876 31.5134H61.3837V34.3411H60.876V31.5134Z' fill='#424852' />
      <path
        d='M31.0365 57.9702C34.945 57.9702 38.1135 54.8017 38.1135 50.8932C38.1135 46.9847 34.945 43.8162 31.0365 43.8162C27.128 43.8162 23.9595 46.9847 23.9595 50.8932C23.9595 54.8017 27.128 57.9702 31.0365 57.9702Z'
        fill='#E4E8EB'
      />
      <path
        d='M32.318 43.9411V57.853C31.904 57.9311 31.4743 57.978 31.0369 57.978C30.5995 57.978 30.1777 57.939 29.7559 57.853V43.9411C30.1699 43.863 30.5995 43.8162 31.0369 43.8162C31.4743 43.8162 31.904 43.8552 32.318 43.9411Z'
        fill='#CAD0D7'
      />
      <path
        d='M38.3245 58.6576L33.8799 52.1821L38.4182 49.0654C40.207 47.839 42.6519 48.2921 43.8783 50.0808C45.1047 51.8696 44.6516 54.3146 42.8629 55.5409L38.3245 58.6576Z'
        fill='#FDCD56'
      />
      <path
        d='M33.8799 52.1819L38.3246 58.6574L33.7862 61.7741C31.9974 63.0005 29.5525 62.5475 28.3261 60.7587C27.0997 58.9699 27.5528 56.525 29.3416 55.2986L33.8799 52.1819Z'
        fill='#EB5463'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_17977'>
        <rect width='50' height='50' fill='white' transform='translate(15.4282 15)' />
      </clipPath>
    </defs>
  </svg>
));
EmergencyMedicineIcon.displayName = 'EmergencyMedicineIcon';

export default EmergencyMedicineIcon;
